import type { ModalPropsForType } from '#/containers/Modal/modalComponentByType';
import type { ModalType } from '#/containers/Modal/ModalType';

export const openModalAttr = 'data-modal';
export const openModalPropsAttr = 'data-modal-props';

export type OpenModalData = {
  [T in ModalType]: {
    type: T;
    props: ModalPropsForType<T>;
  };
}[ModalType];

/**
 * There is no snippet for openModal because it is not used directly,
 * but rather via ClickActions
 */
export function openModalAttributes(data: OpenModalData | undefined) {
  if (!data) return {};

  const attributes: Record<string, unknown> = {
    [openModalAttr]: data.type,
  };

  if (data.props) {
    attributes[openModalPropsAttr] = JSON.stringify(data.props);
  }

  return attributes;
}
